import Icon from '../components/Icon.vue'

Icon.register({"trophy":{"width":576,"height":512,"paths":[{"d":"M552 64H448V24C448 10.7 437.3 0 424 0H152C138.7 0 128 10.7 128 24V64H24C10.7 64 0 74.7 0 88V144C0 179.7 22.5 216.4 61.9 244.7 93.4 267.4 131.7 281.8 171.9 286.4 203.3 338.5 240 360 240 360V432H192C156.7 432 128 452.7 128 488V500C128 506.6 133.4 512 140 512H436C442.6 512 448 506.6 448 500V488C448 452.7 419.3 432 384 432H336V360S372.7 338.5 404.1 286.4C444.4 281.8 482.7 267.4 514.1 244.7 553.4 216.4 576 179.7 576 144V88C576 74.7 565.3 64 552 64zM99.3 192.8C74.9 175.2 64 155.6 64 144V128H128.2C129.2 160.6 134 189.2 141 214.2 125.9 209 111.8 201.8 99.3 192.8zM512 144C512 160.1 494.3 180.1 476.7 192.8 464.2 201.8 450 209 434.9 214.2 441.9 189.2 446.7 160.6 447.7 128H512V144z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/trophy.js
// module id = a4ey
// module chunks = 0